import * as React from 'react';
import { PaymentInstructionLayout } from '../../../component/PaymentInstructionLayout.js';

const Ideal = ()=>{
    return /*#__PURE__*/ React.createElement(PaymentInstructionLayout, {
        info: "checkout.payment.method.ideal.info"
    });
};

export { Ideal };
//# sourceMappingURL=Ideal.js.map
